import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import TrasyService from "./TrasyService";
import TrasyTable from "./components/TrasyTable";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../shared/headers/KonfiguracjaHeader";
import TrasyForm from "./components/TrasyForm";
import MiejscowosciService from "../miejscowosci/MiejscowosciService";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import PokazTraseNaMapieContainer from "./googleMapComponents/PokazTraseNaMapieContainer";
import LinieService from "../linie/LinieService";
import ScrollUtilities from "../../../../utilities/ScrollUtilities";

export default class TrasyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            linie: [],
            trasy: [],
            trasa: null,
            trasaNaMapie: null,
            miejscowosci: [],
            pokazFormularz: false,
            wlaczSzukanie: true,
        };
        this.pobierzTrasy = this.pobierzTrasy.bind(this);
        this.pobierzMiejscowosci = this.pobierzMiejscowosci.bind(this);
        this.pokazFormularz = this.pokazFormularz.bind(this);
        this.zamknijFormularz = this.zamknijFormularz.bind(this);
        this.onClickEdytuj = this.onClickEdytuj.bind(this);
        this.onClickUsun = this.onClickUsun.bind(this);
        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onChangeStatus = this.onChangeStatus.bind(this);
        this.onChangeRezerwacja = this.onChangeRezerwacja.bind(this);
        this.onChangeSprzedaz = this.onChangeSprzedaz.bind(this);
        this.onClickPokazTraseNaMapie = this.onClickPokazTraseNaMapie.bind(this);
        this.onChangeTrasaOdwrotna = this.onChangeTrasaOdwrotna.bind(this);
    }

    componentDidMount() {
        this.pobierzTrasy()
        this.pobierzMiejscowosci()
        this.pobierzLinie()
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    pobierzMiejscowosci() {
        MiejscowosciService.getMiejscowosci().then(function (response) {
            this.setState({miejscowosci: response.data.content})
        }.bind(this))
    }

    pobierzLinie(){
        LinieService.getLinie().then(function (response) {
            this.setState({linie: response.data.content})
        }.bind(this))
    }

    pokazFormularz() {
        this.setState({pokazFormularz: true})
        ScrollUtilities.scrollToTop()
    }

    zamknijFormularz() {
        this.setState({pokazFormularz: false, trasa: null})
    }

    onClickEdytuj(obj) {
        this.pokazFormularz();
        this.setState({trasa: obj})
    }

    onClickPokazTraseNaMapie(obj){
        this.setState({
            trasaNaMapie:obj,
        })
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc trasę: ' + obj.nazTr)) {
            TrasyService.deleteTrasa(obj.idTr).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto miejscowość', "", 3000)
                    this.pobierzTrasy();
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania miejscowości', "", 3000)
                }
            }.bind(this))
        }
    }

    onClickZapisz(obj, czyEdycja) {
        if (czyEdycja) {
             TrasyService.editTrasa(this.state.trasa.idTr, obj).then(function (response) {
                 if (response.status < 300) {
                     this.refs.notificator.success('Pomyślnie edytowano trasę', "", 3000)
                     this.pobierzTrasy();
                 }
                 else {
                     this.refs.notificator.error('Wystąpił błąd podczas edytowania trasy', "", 3000)
                 }
             }.bind(this))

        }
        else {
             TrasyService.addTrasa(obj).then(function (response) {
                 if ((response.status < 300)) {
                     this.refs.notificator.success('Pomyślnie dodano trasę', "", 3000)
                     this.pobierzTrasy();
                 }
                 else {
                     this.refs.notificator.error('Wystąpił błąd podczas dodawania trasy', "", 3000)
                 }
             }.bind(this))
        }

        this.zamknijFormularz();

    }

    onChangeStatus(obj,nowy){
        let data = obj;
        data['status'] = nowy;
        TrasyService.editTrasa(obj.idTr, obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono status', "", 3000)
                this.pobierzTrasy();
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany statusu', "", 3000)
            }
        }.bind(this))
    }

    onChangeRezerwacja(obj,nowy){
        let data = obj;
        data['erezerwacja'] = nowy;
        TrasyService.editTrasa(obj.idTr, obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono możliwość rezerwacji', "", 3000)
                this.pobierzTrasy();
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas możliwości rezerwacji', "", 3000)
            }
        }.bind(this))
    }

    onChangeSprzedaz(obj,nowy){
        let data = obj;
        data['esprzedaz'] = nowy;
        TrasyService.editTrasa(obj.idTr, obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono możliwość sprzedazy', "", 3000)
                this.pobierzTrasy();
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas możliwości sprzedazy', "", 3000)
            }
        }.bind(this))
    }

    onChangeTrasaOdwrotna(trasa,trasaOdwrotna){
        let data = trasa;
        data['idTrPow'] = Boolean(trasaOdwrotna)? trasaOdwrotna.idTr : null
        TrasyService.editTrasa(trasa.idTr, data).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie zmieniono trasę odwrotną', "", 3000)
                this.pobierzTrasy();
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas zmiany trasy odwrotnej', "", 3000)
            }
        }.bind(this))

    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history} collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'TrasyContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-trasami',
                                    text: 'Zarządzanie trasami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-trasami/trasy', text: 'Trasy'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <TopIf isTrue={!Boolean(this.state.pokazFormularz) && !Boolean(this.state.trasaNaMapie)}>
                                <KonfiguracjaHeader pokazFormularz={this.pokazFormularz}
                                                    tekstDodaj={'Dodaj trasę'}
                                                    pokazButtonSzukaj={false}
                                />
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.trasaNaMapie)}>
                                <PokazTraseNaMapieContainer trasa={this.state.trasaNaMapie} handleClickZamknij={()=>{this.setState({trasaNaMapie:null})}}/>
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazFormularz) && (this.state.miejscowosci.length > 0)}>
                                <TrasyForm handleClickZapisz={this.onClickZapisz}
                                           handleClickAnuluj={this.zamknijFormularz}
                                           trasa={this.state.trasa}
                                           miejscowosci={this.state.miejscowosci}
                                           trasy={this.state.trasy}
                                />
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.pokazFormularz) && !(this.state.miejscowosci.length > 0)}>
                                <TopAlertUwaga text={'Nie można wyświetlić formularza - brak miejscowości'}/>
                            </TopIf>
                            <TopIf isTrue={Boolean(this.state.trasy)}>
                                <TrasyTable data={this.state.trasy}
                                            wlaczSzukanie={this.state.wlaczSzukanie}
                                            handleEdytuj={this.onClickEdytuj}
                                            handleUsun={this.onClickUsun}
                                            handleZmienStatus={this.onChangeStatus}
                                            handleZmienRezerwacje={this.onChangeRezerwacja}
                                            handleZmienSprzedaz={this.onChangeSprzedaz}
                                            handleClickPokazTraseNaMapie={this.onClickPokazTraseNaMapie}
                                            handleChangeTrasaOdwrotna={this.onChangeTrasaOdwrotna}
                                            linie={this.state.linie}
                                />
                            </TopIf>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/trasy/TrasyContainer.js